<template>
  <div
    class="flex pb-4 border-b border-gray-200 space-y-3 sm:flex sm:items-center sm:justify-between sm:space-x-4 sm:space-y-0"
  >
    <div class="inline-flex">
      <div class="relative rounded-md shadow-sm">
        <input
          id="search"
          v-model="searchinputbuffer"
          class="focus:ring-indigo-500 focus:border-indigo-500 block w-full h-full pb-1 pl-3 pr-12 sm:text-sm border-gray-300 rounded-md"
          placeholder="Buscar"
        />
      </div>
      <span class="inline-flex rounded-md shadow-sm pl-4">
        <button
          v-on:click="onSearch"
          type="button"
          class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 text-xs leading-4 font-medium rounded text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150"
        >
          <!-- Heroicon name: mail -->
          <svg
            class="-ml-0.5 mr-2 h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          {{ $t('message.wms.pickingmenu.buscar') }}
        </button>
      </span>
    </div>
    <div class="flex justify-end">
      <span class="inline-flex rounded-md shadow-sm">
        <button
          type="button"
          v-on:click="newOrder()"
          class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 text-xs leading-4 font-medium rounded text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700 transition duration-150 ease-in-out"
        >
          <svg
            class="-ml-0.5 mr-2 h-6 w-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            ></path>
          </svg>
          {{ $t('message.wms.pickingmenu.nuevaorden') }}
        </button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'picking-orders-menu',
  data() {
    return {
      searchinputbuffer: '',
      searchinput: ''
    };
  },
  methods: {
    onSearch() {},
    async newOrder() {
      await this.$http.post(`wms/pickingorders`, {});
      // emit event to update PickingTable (sibling component)
      this.$root.$emit('new-picking-order');
    }
  }
};
</script>
